import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const createDiscount = (_, params) => {
  return Api(endPoints.discount, params, requestType.POST);
};

const getAllDiscount = () => {
  return Api(endPoints.discount, null, requestType.GET);
};

const getProspectDiscount = (length, profit) => {
  return Api(
    `${endPoints.getProspectDiscount}?length=${length}&price=${profit}`,
    null,
    requestType.GET
  );
};

const updateDiscount = (id, params) => {
  return Api(`${endPoints.discount}/${id}`, params, requestType.PUT);
};

export { createDiscount, updateDiscount, getAllDiscount, getProspectDiscount };
